import React from 'react'
import { BrowserRouter } from 'react-router-dom'
import { hydrate, render } from 'react-dom'
import { Provider } from 'react-redux'
import { init as SentryInit, ErrorBoundary as SentryErrorBoundary } from '@sentry/react'
import { PersistGate } from 'redux-persist/integration/react'
import { persistStore } from 'redux-persist'
import { CookiesProvider } from 'react-cookie'
import { HelmetProvider } from 'react-helmet-async'
import { loadableReady } from '@loadable/component'

import { App } from '@app/app'
import { createStore } from '@app/store/store'
import { runtimeConfig } from '@app/common/config'
import { ScrollToTop } from '@app/utils/scrollToTop'

import { registerServiceWorker } from './serviceWorker'

if (runtimeConfig.joinSproutTherapyConfig?.SENTRY_DSN) {
  SentryInit({
    dsn: runtimeConfig.joinSproutTherapyConfig?.SENTRY_DSN,
    environment: runtimeConfig.joinSproutTherapyConfig?.ENV_NAME,
    // We recommend adjusting this value in production, or using tracesSampler
    // for finer control
    tracesSampleRate: 1.0
  })
}

const initialState = window.__INITIAL_STATE__
const renderMethod = window.__RENDER_METHOD__ === 'render' ? render : hydrate

const store = createStore(initialState)
const persistor = persistStore(store)

registerServiceWorker()

loadableReady(() => {
  renderMethod(
    <SentryErrorBoundary>
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <BrowserRouter>
            <ScrollToTop />
            <CookiesProvider>
              <HelmetProvider>
                <App />
              </HelmetProvider>
            </CookiesProvider>
          </BrowserRouter>
        </PersistGate>
      </Provider>
    </SentryErrorBoundary>,
    document.getElementById('root'),
    () => delete window.__INITIAL_STATE__
  )
})
